import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = "https://sgpbqmkhqwrusgscsufo.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNncGJxbWtocXdydXNnc2NzdWZvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU1NTM2ODEsImV4cCI6MjA4MTEyOTY4MX0.D-YoXEkibYIENPXZz3Jnl_3Ag98hPnqqtkhC7NGJKeU";

let supabase = null;
let isSupabaseConfigured = false;

if (SUPABASE_URL && SUPABASE_KEY) {
    try {
        supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
        isSupabaseConfigured = true;
    } catch (error) {
        console.error("Supabase Init Error:", error);
    }
}

export { supabase, isSupabaseConfigured };